export const onboardingSecondaryContainedButtonSx = {
  bgcolor: 'grey.300',
  color: 'text.primary',
  '&:hover': {
    bgcolor: 'grey.400',
  },
};
